export function createManageablePromise(callbacks) {
    let _promise;
    let _resolve;
    let _reject;
    function clear() {
        if (_promise) {
            const past = { reject: _reject, resolve: _resolve };
            _promise = undefined;
            _resolve = undefined;
            _reject = undefined;
            return past;
        }
        return undefined;
    }
    return {
        promise(execute) {
            if (_promise) {
                return _promise;
            }
            _promise = new Promise((resolve, reject) => {
                _resolve = resolve;
                _reject = reject;
                if (execute) {
                    execute(_resolve, _reject);
                }
            });
            return _promise;
        },
        reject(err) {
            if (_reject) {
                clear()?.reject(err);
                callbacks?.onReject(err);
            }
            // TODO remove, not really errors
            // console.error(`no pending promise, cannot reject`);
        },
        resolve(value) {
            if (_resolve) {
                clear()?.resolve(value);
                callbacks?.onResolve(value);
            }
            // TODO remove, not really errors
            // console.error(`no pending promise, cannot resolve`);
        },
    };
}
export function createManageablePromiseWithId(callbacks) {
    let _mapping = {};
    function clear(id) {
        if (id) {
            if (_mapping[id]) {
                const past = {
                    reject: _mapping[id].reject,
                    resolve: _mapping[id].resolve,
                };
                delete _mapping[id];
                return past;
            }
        }
        else {
            const allIds = Object.keys(_mapping);
            for (const id of allIds) {
                clear(id);
            }
        }
        return undefined;
    }
    return {
        exists(id) {
            return !!_mapping[id];
        },
        promise(id, execute) {
            if (_mapping[id]) {
                return _mapping[id].promise;
            }
            _mapping[id] = {};
            _mapping[id].promise = new Promise((resolve, reject) => {
                _mapping[id].resolve = resolve;
                _mapping[id].reject = reject;
                if (execute) {
                    execute(_mapping[id].resolve, _mapping[id].reject);
                }
            });
            return _mapping[id].promise;
        },
        reject(ids, err) {
            // console.log(`reject : ${ids}`);
            if (ids === '' || ids === '*') {
                const allIds = Object.keys(_mapping);
                for (const id of allIds) {
                    clear(id)?.reject(err);
                }
            }
            else {
                if (typeof ids === 'string') {
                    if (_mapping[ids]) {
                        clear(ids)?.reject(err);
                        callbacks?.onReject(err);
                    }
                }
                else {
                    for (const id of ids) {
                        if (_mapping[id]) {
                            clear(id)?.reject(err);
                            callbacks?.onReject(err);
                        }
                    }
                }
            }
        },
        resolve(ids, value) {
            // console.log(`resolve : ${ids}`);
            if (ids === '' || ids === '*') {
                const allIds = Object.keys(_mapping);
                for (const id of allIds) {
                    clear(id)?.resolve(value);
                }
            }
            else {
                if (typeof ids === 'string') {
                    if (_mapping[ids]) {
                        clear(ids)?.resolve(value);
                        callbacks?.onResolve(value);
                    }
                }
                else {
                    for (const id of ids) {
                        if (_mapping[id]) {
                            clear(id)?.resolve(value);
                            callbacks?.onResolve(value);
                        }
                    }
                }
            }
        },
        // cancel(ids: string | string[]) {
        // 	console.log(`cancel : ${ids}`);
        // 	if (ids === '' || ids === '*') {
        // 		const allIds = Object.keys(_mapping);
        // 		for (const id of allIds) {
        // 			clear(id);
        // 		}
        // 	} else {
        // 		if (typeof ids === 'string') {
        // 			if (_mapping[ids]) {
        // 				clear(ids);
        // 			}
        // 		} else {
        // 			for (const id of ids) {
        // 				if (_mapping[id]) {
        // 					clear(id);
        // 				}
        // 			}
        // 		}
        // 	}
        // },
    };
}
